import React from 'react';
import styled from 'styled-components';

const SIZE_MAP = {
  S: '--spectrum-global-dimension-font-size-50',
  M: '--spectrum-global-dimension-font-size-75',
  L: '--spectrum-global-dimension-font-size-100',
  XL: '--spectrum-global-dimension-font-size-200',
};

const CustomHeading = styled.h2`
  font-size: var(${({ $size }) => SIZE_MAP[$size]});
  text-transform: uppercase;
`;

/**
 * Heading that renders uppercase text. Based on https://spectrum.adobe.com/page/detail/
 * @param {import('./types').DetailHeadingProps} props
 */
const DetailHeading = ({ children, size = 'M', level = 2, ...props }) => {
  const tag = `h${level}`;
  return (
    <CustomHeading as={tag} $size={size} {...props}>
      {children}
    </CustomHeading>
  );
};

export default DetailHeading;
